import { useMutation, useQueryClient } from '@tanstack/react-query';
import service from '../service';
import type { UpdateToastGuidSettingPayload } from '../types/toastGuidSetting';
import { toastGuidSettingQueryKeys } from './useToastGuidSettings';

export function useUpdateToastGuidSetting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: UpdateToastGuidSettingPayload;
    }) => service.updateToastGuidSetting(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: toastGuidSettingQueryKeys.all,
      });
    },
  });
}
